import { get, post } from "../util/activation1.3";
import md5 from "js-md5";

// 钉钉免登录 /ding/newTask/dingAppAuth POST
export const dingAppAuth = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post('/ding/newTask/dingAppAuth', params);
};

// 获取token登录信息 /api/ding/account/dingLogin POST
export const dingLogin = (data) => {
    const date = parseInt(Date.now() / 1000);
    data.time = date;
    data.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/ding/account/dingLogin", data);
};
